import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function InfoTooltip({ text, describedById }) {
    if (!text) return null;
    return (
        <button
            type="button"
            className="relative group inline-flex items-center justify-center w-5 h-5 rounded-full border border-gray-300 text-gray-500 text-[8px] ml-2 select-none focus:outline-none focus:ring-2 focus:ring-primary/20"
            aria-label="Help"
            aria-describedby={describedById}
        >
            <FontAwesomeIcon icon={faInfo} />
            {/* bubble */}
            <span
                className="absolute left-1/2 -translate-x-1/2 top-full mt-2 z-20 rounded-md bg-gray-900 text-white text-xs p-3 shadow-lg opacity-0 pointer-events-none transition-opacity
                   group-hover:opacity-100 group-focus:opacity-100 w-max"
                role="tooltip"
            >
                {text}
                {/* little arrow */}
                <span className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 rotate-45 bg-gray-900" />
            </span>
        </button>
    );
}